<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Foreword#For">Foreword</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">The Ships Named <i>Alabama</i></span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">Commanding USS <i>Alabama</i></span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample"><i>Alabama</i>’s Armament and “Big Guns”</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">Working Aboard <i>Alabama</i></span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">Life on <i>Alabama</i></span></td></tr>
<tr><td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter6#C6" title="Link target outside of Sample">Faith and Healing at Sea</span></td></tr>
<tr><td><span href="#/Chapter7#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter7#C7" title="Link target outside of Sample">Earning Nine Battle Stars</span></td></tr>
<tr><td><span href="#/Chapter8#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter8#C8" title="Link target outside of Sample">Bringing <i>Alabama</i> Home</span></td></tr>
<tr><td colspan="2"><span href="#/About#Abt" title="Link target outside of Sample">About the USS Alabama Battleship Memorial Park</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?48244493